import {CardChart} from "../card.chart";
import TextField from "@material-ui/core/TextField";
import {TIPOS_GRAFICO} from "../tipos.grafico";
import MenuItem from "@material-ui/core/MenuItem";
import {RankingTable} from "../charts/ranking.table";
import React, {useEffect, useState} from "react";
import {useSnackbar} from "notistack";
import {useEstadisticasService} from "../../../../../services/hooks";
import {imageChartToPDF, tableChartToPDF} from "../../../../../assets/utils";

export const RankingArticulosCard = ({settingsState, printRef}) => {
    const [rankingArticulos, setRankingArticulos] = useState([]);
    const [tipoRankingArticulos, setTipoRankingArticulos] = useState(TIPOS_GRAFICO[0]);

    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const EstadisticasService = useEstadisticasService();

    const chartTitle = "Ranking Articulos";
    const chartSubtitle = tipoRankingArticulos.description;

    useEffect(() => {
        EstadisticasService.getRankingArticulos(
            settingsState,
            success => setRankingArticulos(success.data.result),
            error => enqueueSnackbar(error, {variant: 'error'})
        )
    }, [settingsState]);

    return (
        <CardChart
            title={chartTitle}
            subtitle={chartSubtitle}
            rightContent={
                <TextField
                    select
                    value={tipoRankingArticulos}
                    onChange={event => setTipoRankingArticulos(event.target.value)}
                >
                    {TIPOS_GRAFICO.map((tipo, index) => (
                        <MenuItem key={index} value={tipo}>{tipo.description}</MenuItem>
                    ))}
                </TextField>
            }
            exportFn={tableChartToPDF.bind(null, printRef, chartTitle, chartSubtitle, settingsState.dates)}
        >
            <RankingTable
                data={rankingArticulos}
                height={800}
                id={'codigo'}
                value={tipoRankingArticulos}
                printRef={printRef}
            />
        </CardChart>
    )
}
